<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modal__backdrop" @click="closeModal()" />

      <div :class="'modal__dialog ' + hasImage" :style="containerStyle">
        <div class="modal__header" :style="headerStyleAttr">
          <slot name="header" />
          <button
            type="button"
            title="Close (Esc)"
            class="modal__close"
            @click="closeModal()"
          >
            ×
          </button>
        </div>
        <div class="modal__body" :style="bodyStyleAttr" ref="menuItem4">
          <div class="app-container">
            <div class="menuItem_title">
              <h3>{{ name }}</h3>
              <small>{{ description }}</small>
              <button
                v-if="showSecondaryClose"
                type="button"
                title="Close (Esc)"
                class="modal__close"
                @click="closeModal()"
              >
                ×
              </button>
            </div>
            <div class="modifiersContainer" :data-productid="id">
              <input type="text" autofocus="autofocus" style="display: none" />
              <div
                v-for="(modifier, index) in productModifiers"
                :key="modifier.id"
                id="menuItem_question"
                class="menuItem_question"
                :data-id="modifier.id"
                :data-min="modifier.minimum"
                :data-max="modifier.maximum"
                :data-inclusive="modifier.inclusive"
              >
                <h4>
                  {{ index + 1 }}. Choose your {{ modifier.name }}
                  {{ modifier.minimum >= 1 ? "*" : null }}
                </h4>
                <span v-if="modifier.minimum > 1" class="p-l-20 text-muted"
                  >Please select at least {{ modifier.minimum }} options:</span
                >
                <div
                  v-for="choice in modifier.choices"
                  :key="choice.id"
                  class="menuItem_options"
                  :data-id="choice.id"
                >
                  {{ choice.name }}
                  <span v-if="choice.price > 0" class="badge modifier-price">{{
                    choice.price
                  }}</span>
                </div>
              </div>
              <br />
              <h4>Add any Special Instructions</h4>
              <input
                type="text"
                class="form-control"
                name="special-instructions"
                maxlength="160"
                placeholder="Special instructions"
                autocomplete="false"
                spellcheck="true"
              />
              <br /><br />
              <div class="menuItem_total">
                <form>
                  <div
                    class="value-button-left updateQuantity"
                    id="decrease"
                    data-diff="-1"
                    value="Decrease Value"
                  >
                    <i class="fa fa-minus-circle"></i>
                  </div>
                  <input type="number" id="number" value="1" />
                  <div
                    class="value-button-right updateQuantity"
                    id="increase"
                    data-diff="1"
                    value="Increase Value"
                  >
                    <i class="fa fa-plus-circle"></i>
                  </div>
                </form>
                <div class="price_container">
                  <span v-if="productModifiers.length > 0">
                    Item extras :
                    <span class="total-modifiers-price">0.00</span>
                  </span>
                  <span>
                    Total item price :
                    <span class="total-price" :data-price="price">{{
                      price.toFixed(2)
                    }}</span>
                  </span>
                </div>
                <div class="action-container">
                  <div
                    :class="addToCartButtonClass"
                    :style="{ 'background-color': accentColor }"
                  >
                    Add to cart
                  </div>
                  <div
                    v-if="$hasItemsInCart"
                    class="menuItem_checkout"
                    :style="{ 'background-color': accentColor }"
                  >
                    Proceed to checkout
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal__footer" style="padding: 0px">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "MenuItemModal",
  props: {
    containerStyle: String,
    headerStyle: String,
    bodyStyle: String,
    footerStyle: String,
  },
  data() {
    return {
      show: false,
      containerStyleAttr: !this.isStringNullOrEmpty(this.containerStyle)
        ? this.containerStyle
        : "",
      headerStyleAttr: !this.isStringNullOrEmpty(this.headerStyle)
        ? this.headerStyle
        : "",
      bodyStyleAttr: !this.isStringNullOrEmpty(this.bodyStyle)
        ? this.bodyStyle
        : "",
      footerStyleAttr: !this.isStringNullOrEmpty(this.footerStyle)
        ? this.footerStyle
        : "",

      id: Number,
      name: "",
      description: "",
      imageURL: "",
      hasImage: "",
      price: 0.0,
      productModifiers: [],
      showSecondaryClose: false,
    };
  },
  computed: {
    accentColor: function () {
      return this.$franchiseAccentColor;
    },
    addToCartButtonClass: function () {
      var classList = "menuItem_add";
      if (!this.$hasItemsInCart) classList += " full";
      return classList;
    },
  },
  methods: {
    closeModal() {
      this.show = false;
    },
    openModal(id) {
      this.show = true;
      this.id = id;
    },
    populate(data) {
      if (!this.isStringNullOrEmpty(data.imageURL))
        this.headerStyleAttr = 'background-image: url(' + data.imageURL + ')';
      this.showSecondaryClose = this.isStringNullOrEmpty(data.imageURL);
      this.name = data.name;
      this.description = data.description;
      this.imageURL = data.imageURL;
      this.hasImage =
        this.imageURL == '' || this.imageURL == null ? 'no-image' : '';
      this.price = data.price;
      this.productModifiers = data.productModifiers;
    },
  },
  mounted() {},
};
</script>
<style scoped>
@import "./MenuItemModal.vue.css";
.modal {
  display: block;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
}
.modal__backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}
.modal__dialog {
  position: relative;
  width: 600px;
  background-color: #ffffff;
  border-radius: 5px;
  margin: 50px auto auto auto;
  display: flex;
  flex-direction: column;
  z-index: 2;
  max-height: 90vh;
  top: 48%;
  transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
}
.modal__close {
  width: 44px;
  height: 44px;
  line-height: 44px;
  position: absolute;
  right: 0;
  top: 0;
  text-decoration: none;
  text-align: center;
  opacity: 0.65;
  background: transparent;
  border: none;
  font-family: "Open Sans", Arial, sans-serif;
  font-weight: 600;
  font-size: 22px;
}
.modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 20px 10px;
  background-size: contain;
  background-color: white !important;
  background-repeat: no-repeat;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
}
.modal__body {
  padding: 10px 10px 20px 20px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  overflow-x: hidden;
}
.modal__footer {
  padding: 10px 20px 20px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: 992px) {
  .modal__dialog {
    width: 90vw;
  }
}
</style>